import { render, staticRenderFns } from "./Socials.vue?vue&type=template&id=e9fcf106&scoped=true"
import script from "./Socials.js?vue&type=script&lang=js&external"
export * from "./Socials.js?vue&type=script&lang=js&external"
import style0 from "./Socials.scss?vue&type=style&index=0&id=e9fcf106&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fcf106",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Title/Title.vue').default,HotButtonList: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/ButtonList/ButtonList.vue').default,HotContainer: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Templates/Container/Container.vue').default})
